import React, { useState, useEffect } from 'react';
import { ContentHeader, Loader } from '@components';
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getSetting, updateSetting } from '../../services/setting';
import { toast } from 'react-toastify';


const Setting = () => {
  const [isLoading, setLoading] = useState(true);
  const [OverrideValidateAchAccountChecked, setOverrideValidateAchAccountChecked] = useState(false);
  const [fillData, setFillData] = useState({
    OverrideValidateAchAccount: ''
  });

  const updateSettingData = (values: any) => {
    setLoading(true);
    updateSetting(values).then(function (res: any) {
      const resp = res.data;
      setLoading(false);
      if (resp.Acknowledge == 1) {
        toast.success('Setting Successfully updated!');
      } else {
        toast.error('Internal Server Error!');
      }
    }).catch(err => {
      setLoading(false);
      toast.error('Internal Server Error!');
    });
  };

  useEffect(() => {
    getSetting(Object.keys(fillData)).then(function (res: any) {
      const resp = res.data;
      setLoading(false);
      if (res.status === 206 && resp.Acknowledge == 1) {
        const setting = resp.settings;
        setFillData({
          OverrideValidateAchAccount: setting.OverrideValidateAchAccount ? setting.OverrideValidateAchAccount : ''
        });   
        setOverrideValidateAchAccountChecked(setting.OverrideValidateAchAccount > 0 ? true : false);
      }
    }).catch(err => {
      setLoading(false);
      toast.error(err.response.data.FullMessage !== 'undefied' ? err.response.data.FullMessage : 'Internal Server Error!');
    });
  }, [])

  const { handleChange, values, handleSubmit, touched, errors } = useFormik({
    enableReinitialize: true,
    initialValues: fillData,
    validationSchema: Yup.object({
      OverrideValidateAchAccount: Yup.mixed(),
    }),
    onSubmit: (values) => {
      updateSettingData(values);
    }
  });

  const handleChangeCheckbox = (e: any) => { 
    setOverrideValidateAchAccountChecked(e.target.checked);
    handleChange({ target: { name: 'OverrideValidateAchAccount', value: e.target.checked } });
  }



  return (
    <>
      <ContentHeader title="Setting" />
      <section className="content">
        <div className="container-fluid">
          <div className="col-12">
            <form onSubmit={handleSubmit}>
              <div className="card card-primary">
                <div className="card-header">
                  <h3 className="card-title">Manage Settings</h3> 
                </div>
                <div className="card-body">
                  <h6 className="text-primary font-weight-bold">General Setting</h6>
                  <hr />
                  <div className="form-group row">
                    <div className="form-group col-md-4">
                      <div className="custom-control custom-switch">
                        <input type="checkbox"
                          className="custom-control-input"
                          id="OverrideValidateAchAccount"
                          name="OverrideValidateAchAccount"
                          value={values.OverrideValidateAchAccount ? 1 : 0}
                          checked={OverrideValidateAchAccountChecked}
                          onChange={handleChangeCheckbox}
                        />
                        <label className="custom-control-label" htmlFor={`OverrideValidateAchAccount`}>OVERRIDE VALIDATE ACH ACCOUNT</label>
                      </div>
                    </div>
                  </div>
                </div>
                <Loader isLoading={isLoading} />
                <div className="card-footer">
                  <button type="submit" className="btn btn-primary">Update</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Setting;
